import { Card, Divider, Form, Tabs, Title } from '@bancobarigui/barihaus';
import { Spin } from 'antd';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { ProviderForm } from '@/pages/ProviderRegister/ProviderForm';
import { AddressFormItem } from '@/components/AddressForm';
import { ValueRangeItem } from '@/components/ValueRangeItem';
import { SwitchCardItem } from '@/components/SwitchCardItem';
import { PropertyTypesTransfer } from '@/components/PropertyTypesTransfer';
import { InspectionTypesTransfer } from '@/components/InspectionTypesTransfer';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';

import { useProviderCompanyEdit } from './useProviderCompanyEdit';

function ProviderCompanyEditContent() {
  const {
    form,
    loading,
    submitting,
    handleSubmit,
    handleCancel,
  } = useProviderCompanyEdit();

  if (loading) {
    return (
      <div className="flex justify-center items-center" style={{ minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Form form={form} name="basic" onFinish={handleSubmit} className="space-y-8">
        <Card>
          <ProviderForm />
        </Card>

        <Title level={5}>Endereço da Prestadora</Title>

        <AddressFormItem form={form} />

        <Divider>Configurações</Divider>

        <SwitchCardItem
          title="Permitir recebimento de demandas"
          name="allowsDemandReceiving"
          text="Ao habilitar esta opção, a prestadora ficará habilitada a receber novos
                direcionamentos"
        />

        <Tabs
          items={[
            {
              key: '1',
              label: 'Tipos de Inspeção',
              children: <InspectionTypesTransfer />,
            },

            {
              key: '2',
              label: 'Tipos de Imovel',
              children: <PropertyTypesTransfer />,
            },

            {
              key: '3',
              label: 'Valor',
              children: <ValueRangeItem />,
            },
          ]}
        />

        <RegisterFormButtons onClickCancel={handleCancel} loading={submitting} />
    </Form>
  );
}

export function ProviderCompanyEdit() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Editar Prestadora" />}
    >
      <FeatureAlert services={['registration']} />
      <ServiceCheck
        services={['registration']}
        featureName="Edicao de Prestadora"
      >
        <ProviderCompanyEditContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
